export async function isWaiverSigned (): Promise<boolean> {
    return Promise.resolve(true);

    const response = await useAPI<{ success: boolean, data: { isSigned: boolean } }>('/v1/user/waiver/status', {
        method: 'GET',
    });

    return response.data?.isSigned || false;
}

export async function getWaiverLink (): Promise<string> {
    const response = await useAPI<{ success: boolean, data: { waiverUrl: string } }>('/v1/user/waiver/link', {
        method: 'GET',
    });

    return response.data?.waiverUrl || '';
}
